import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import Button from "@mui/material/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ViewPass from "../../Assets/viewPassword.svg";
import unViewPass from "../../Assets/unviewPassword.svg";
import axios from "axios";
import Headers from "../../Components/Headers";
import "./app.css"

const BaseUrl = "https://blackboxnow.com/api";

const LoginClr = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // local state (replacing context)
  const [values, setValues] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [clsroom, setClsroom] = useState(false);

  // existing locals
  const [viewPass, setViewPass] = useState(false);
  const [clssroom, setClssroom] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  let lid = searchParams.get("l");
  if (!lid) lid = "1";

  const clicked = () => setViewPass(!viewPass);

  useEffect(() => {
    setLoading(false);
    if (clsroom) {
      setClssroom(true);
      setClsroom(false);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
    // eslint-disable-next-line
  }, []);

  const changeHandler = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const loginBtnj = async (e) => {
    e.preventDefault();
    try {
      if (clssroom) await setClsroom(true);

      setLoading(true);

      const payload = {
        email: values.email,
        password: values.password,
      };

      const endpoint = `${BaseUrl}/login/classroomV2`;
      const { data } = await axios.post(endpoint, payload);
      console.log(data, "dataaaaaaaaaaaaa");

      // Save exactly like signup
      localStorage.setItem("tokenClr", data.token);
      localStorage.setItem("emailClr", data.result?.email_id);

      if (data.result?.ClassroomId) {
        localStorage.setItem("clrId", data.result.ClassroomId);
        navigate("/classroomv2/hub");
        return;
      }

      navigate("/classroomv2/join");
    } catch (err) {
      const msg = err?.response?.data?.message || "Login failed";
      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  const google = () => {
    window.location.href = `${BaseUrl}/signup/google`;
  };

  const facebook = () => {
    window.location.href = `${BaseUrl}/signup/facebook`;
  };

  return (
    <>
     <Headers/>
      <Container fluid className="loginpage p-0 m-0 mt-5">
        {/* <div className="loginBanner2">
          <span className="faded gb mt-5" style={{ width: "auto" }}>
            Welcome to
          </span>
          <span
            className="bold gb mmmmmmm mt-2"
            style={{ lineHeight: "5.5vw", marginTop: "0" }}
          >
            Black Box
          </span>
          <span className="faded gb mt-2" style={{ width: "auto" }}>
            Classroom.
          </span>
        </div> */}

       

        <Container fluid className="d-flex justify-content-center page p-0 m-0">
          <div className="logindiv">
            {/* <div className="optionInSignin">
              <h1 className="gb title">Sign In</h1>
              <p className="desc gl">
                Want to create a new account?
                <span>{""} </span>
                <Link to={`/signupClr?l=${lid}`}>
                  <span className="underline gsb cp"> Register</span>
                </Link>
              </p>
            </div> */}

            <form className="d-flex flex-column m-2 mt-4 aassad" onSubmit={loginBtnj}>
              <TextField
                label="Email"
                variant="outlined"
                className="mb-3"
                name="email"
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                onChange={changeHandler}
              />

              <TextField
                type={viewPass ? "text" : "password"}
                label="Password"
                variant="outlined"
                name="password"
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                onChange={changeHandler}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <img
                        className="cp"
                        src={viewPass ? unViewPass : ViewPass}
                        onClick={clicked}
                        alt=""
                      />
                    </InputAdornment>
                  ),
                }}
              />

              <div className="mt-3 d-flex flex-column">
                <div className="mt-1 mb-3 w-100">
                  <Button variant="contained" type="submit" className="bgdark w-100">
                    {loading ? (
                      <>
                        <div className="loadingio-spinner-rolling-jm01qv7mmak mx-2">
                          <div className="ldio-cqj9sf9mcdj">
                            <div> </div>
                          </div>
                        </div>
                        Logging in
                      </>
                    ) : (
                      "  Enter"
                    )}
                  </Button>
                </div>
                {/* <Link to="/otplogin" className="underline gl fpassqord" style={{ width: "fit-content", color: "black", cursor: "pointer" }}>
                  Forgot Password?
                </Link> */}
              </div>
            </form>

            {/* <GoogleLoginButton className="jonathanClassRoom" onClick={google} /> */}
            {/* <FacebookLoginButton onClick={facebook} /> */}
          </div>
        </Container>
      </Container>
      <div className="footerBox">
      <p>Powered by <span>BLACKBOX CLASSROOM</span></p>
    </div>
    </>
  );
};

export default LoginClr;
